import React from 'react';

const BonusesSection = () => {
  const bonuses = [
    {
      number: 1,
      title: "E-Book: 23 Principles",
      description: "Proven strategies to enhance payment collection and maintain cash flow.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      color: "from-red-500 to-rose-500"
    },
    {
      number: 2,
      title: "1-Year Private Community Membership",
      description: "Continuous support and exclusive resources for business growth and payment recovery.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      color: "from-indigo-500 to-blue-500"
    },
    {
      number: 3,
      title: "Exclusive Weekly 1-to-1 with Rushneek Sir",
      description: "Get exclusive access to a special 1-to-1 call every Monday, available only for community members, where you can directly ask your questions and receive personalized guidance.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      ),
      color: "from-blue-500 to-cyan-500"
    },
    {
      number: 4,
      title: "Payment Recovery Masterclass Blueprint",
      description: "A comprehensive blueprint to master payment recovery strategies for your business.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      color: "from-purple-500 to-pink-500"
    },
    {
      number: 5,
      title: "Live Q&A Sessions",
      description: "I go live every Saturday, where you can ask me your questions directly and get real-time solutions to your challenges.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
      color: "from-green-500 to-emerald-500"
    },
    {
      number: 6,
      title: "Payment Collection Text Scripts",
      description: "Ready-to-use scripts for professional client communication and timely payments.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      ),
      color: "from-amber-500 to-orange-500"
    }
  ];

  return (
    <section className="relative py-24 bg-black overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-900/20 via-black to-black"></div>
        {/* Floating Shapes */}
        <div className="absolute top-20 left-10 w-32 h-32 border border-amber-500/20 rounded-full animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 border border-orange-500/20 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 border border-amber-500/10 rotate-45 animate-spin" style={{ animationDuration: '20s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/30 rounded-full text-amber-400 text-sm font-medium mb-4">
            🎁 Exclusive Bonuses
          </span>
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
            Get <span className="bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">6 Amazing Bonuses</span> FREE
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Enroll today and unlock these exclusive bonuses worth ₹15,000+ absolutely FREE!
          </p>
        </div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {bonuses.map((bonus, index) => (
            <div 
              key={index}
              className="group relative"
            >
              {/* Card */}
              <div className="relative bg-gradient-to-br from-gray-800/60 to-gray-900/60 backdrop-blur-sm rounded-3xl p-6 border border-gray-700/50 hover:border-amber-500/50 transition-all duration-500 hover:-translate-y-3 hover:shadow-2xl hover:shadow-amber-500/20 h-full">
                {/* Bonus Number Badge */}
                <div className={`absolute -top-3 -left-3 w-12 h-12 bg-gradient-to-br ${bonus.color} rounded-2xl flex items-center justify-center text-white font-black text-xl shadow-lg transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-300`}>
                  {bonus.number}
                </div>

                {/* Gift Icon */}
                <div className="absolute -top-3 -right-3 opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:rotate-12">
                  <span className="text-3xl">🎁</span>
                </div>

                {/* Content */}
                <div className="pt-4">
                  {/* Icon */}
                  <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${bonus.color} bg-opacity-20 rounded-2xl text-white mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    {bonus.icon}
                  </div>
                  
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors duration-300">
                    {bonus.title}
                  </h3>
                  
                  <p className="text-gray-400 leading-relaxed">
                    {bonus.description}
                  </p>
                </div>

                {/* Hover Glow */}
                <div className={`absolute inset-0 bg-gradient-to-br ${bonus.color} opacity-0 group-hover:opacity-5 rounded-3xl transition-opacity duration-500`}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Total Value Banner */}
        <div className="mt-16 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-500/20 via-orange-500/20 to-amber-500/20 blur-xl"></div>
          <div className="relative bg-gradient-to-r from-gray-800/80 to-gray-900/80 backdrop-blur-sm rounded-3xl p-8 border border-amber-500/30">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="text-center md:text-left">
                <p className="text-gray-400 mb-2">Total Bonus Value</p>
                <div className="flex items-center gap-4">
                  <span className="text-3xl font-bold text-gray-500 line-through">₹15,000+</span>
                  <span className="text-4xl font-black bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">FREE</span>
                </div>
              </div>
              <div className="flex items-center gap-2 text-amber-400">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="font-medium">Included with your course enrollment</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BonusesSection;
